import { 
  Utensils, 
  Sofa, 
  Shirt, 
  Droplet, 
  Wine, 
  Zap, 
  Home,
  Sparkles,
  Heart,
  PartyPopper,
  Palmtree,
  Laptop,
  Trophy,
  Gift,
  Luggage,
  Baby, Music 
} from 'lucide-react';

export const giftCategories = [
  { 
    id: 1, 
    slug: 'cocina', 
    name: 'Cocina', 
    icon: '🍳',
    Icon: Utensils,
    color: 'from-orange-400 to-red-500'
  },
  { 
    id: 2, 
    slug: 'muebles', 
    name: 'Muebles', 
    icon: '🛋️',
    Icon: Sofa,
    color: 'from-amber-400 to-orange-500'
  },
  { 
    id: 3, 
    slug: 'blanqueria', 
    name: 'Blanquería', 
    icon: '🛏️',
    Icon: Shirt,
    color: 'from-blue-400 to-indigo-500'
  },
  { 
    id: 4, 
    slug: 'bano', 
    name: 'Baño', 
    icon: '🚿',
    Icon: Droplet,
    color: 'from-cyan-400 to-blue-500'
  },
  { 
    id: 5, 
    slug: 'vajilla', 
    name: 'Vajilla', 
    icon: '🍽️',
    Icon: Wine,
    color: 'from-pink-400 to-rose-500'
  },
  { 
    id: 6, 
    slug: 'electrodomesticos', 
    name: 'Electrodomésticos', 
    icon: '⚡',
    Icon: Zap,
    color: 'from-yellow-400 to-orange-500'
  },
  { 
    id: 7, 
    slug: 'deco', 
    name: 'Decoración', 
    icon: '🎨',
    Icon: Sparkles,
    color: 'from-purple-400 to-pink-500'
  },
  { 
    id: 8, 
    slug: 'jardin', 
    name: 'Jardín', 
    icon: '🌿',
    Icon: Home,
    color: 'from-green-400 to-emerald-500'
  },
  // ✅ NUEVAS CATEGORÍAS
  { 
    id: 9, 
    slug: 'experiencias', 
    name: 'Experiencias', 
    icon: '✈️',
    Icon: Palmtree,
    color: 'from-sky-400 to-blue-500'
  },
  { 
    id: 10, 
    slug: 'tecnologia', 
    name: 'Tecnología', 
    icon: '💻',
    Icon: Laptop,
    color: 'from-slate-400 to-gray-600'
  },
  { 
    id: 11, 
    slug: 'deportes', 
    name: 'Deportes', 
    icon: '⚽',
    Icon: Trophy,
    color: 'from-green-400 to-teal-500'
  },
  { 
    id: 12, 
    slug: 'lujo', 
    name: 'Lujo', 
    icon: '💎',
    Icon: Gift,
    color: 'from-amber-400 to-yellow-500'
  },
  { 
    id: 13, 
    slug: 'viajes', 
    name: 'Viajes', 
    icon: '✈️',
    Icon: Luggage,
    description: 'Experiencias y escapadas para la luna de miel'
  },
  { 
  id: 14, 
  slug: 'bebes', 
  name: 'Bebés', 
  icon: '👶',
  Icon: Baby,
  color: 'from-pink-300 to-purple-400'
},
{ 
  id: 15, 
  slug: 'musica', 
  name: 'Música', 
  icon: '🎵',
  Icon: Music,
  color: 'from-violet-400 to-purple-500'
}
];
// ... resto del mockData
// // Mock gift categories and items
// export const giftCategories = [
//   {
//     id: 1,
//     name: 'Electrodomésticos',
//     slug: 'electrodomesticos',
//     icon: '🔌'
//   },
//   {
//     id: 2,
//     name: 'Viajes y Experiencias',
//     slug: 'viajes',
//     icon: '✈️'
//   },
//   {
//     id: 3,
//     name: 'Hogar y Deco',
//     slug: 'hogar',
//     icon: '🏠'
//   },
//   {
//     id: 4,
//     name: 'Cocina',
//     slug: 'cocina',
//     icon: '🍳'
//   },
//   {
//     id: 5,
//     name: 'Tecnología',
//     slug: 'tecnologia',
//     icon: '💻'
//   },
//   {
//     id: 6,
//     name: 'Luna de Miel',
//     slug: 'luna-de-miel',
//     icon: '🌙'
//   }
// ];

export const mockGifts = [
  // Electrodomésticos
  { id: 1, name: 'Cafetera Express', category: 'electrodomesticos', price: 85000, image: 'https://images.unsplash.com/photo-1517668808822-9ebb02f2a0e6?w=400', reserved: false, description: 'Cafetera profesional para preparar el mejor café' },
  { id: 2, name: 'Licuadora Premium', category: 'electrodomesticos', price: 65000, image: 'https://images.unsplash.com/photo-1570222094114-d054a817e56b?w=400', reserved: true, description: 'Licuadora de alta potencia con múltiples velocidades' },
  { id: 3, name: 'Aspiradora Robot', category: 'electrodomesticos', price: 150000, image: 'https://images.unsplash.com/photo-1558317374-067fb5f30001?w=400', reserved: false, description: 'Limpieza inteligente automática' },
  { id: 4, name: 'Tostadora Retro', category: 'electrodomesticos', price: 45000, image: 'https://images.unsplash.com/photo-1604712364498-f8442dbb5355?w=400', reserved: false, description: 'Tostadora estilo vintage de 4 ranuras' },
  
  // Viajes
  { id: 5, name: 'Noche en Bariloche', category: 'viajes', price: 120000, image: 'https://images.unsplash.com/photo-1506905925346-21bda4d32df4?w=400', reserved: false, description: 'Una noche romántica en la Patagonia' },
  { id: 6, name: 'Cena en Palermo', category: 'viajes', price: 35000, image: 'https://images.unsplash.com/photo-1517248135467-4c7edcad34c4?w=400', reserved: false, description: 'Cena para dos en restaurante gourmet' },
  { id: 7, name: 'Excursión a Mendoza', category: 'viajes', price: 200000, image: 'https://images.unsplash.com/photo-1506377247377-2a5b3b417ebb?w=400', reserved: false, description: 'Fin de semana en viñedos mendocinos' },
  { id: 8, name: 'Pasaje a Brasil', category: 'viajes', price: 180000, image: 'https://images.unsplash.com/photo-1483683804023-6ccdb62f86ef?w=400', reserved: true, description: 'Contribución para pasajes a Río' },
  
  // Hogar
  { id: 9, name: 'Juego de Sábanas Premium', category: 'hogar', price: 55000, image: 'https://images.unsplash.com/photo-1631049307264-da0ec9d70304?w=400', reserved: false, description: 'Sábanas de algodón egipcio' },
  { id: 10, name: 'Lámpara de Pie Moderna', category: 'hogar', price: 72000, image: 'https://images.unsplash.com/photo-1507473885765-e6ed057f782c?w=400', reserved: false, description: 'Iluminación elegante para el living' },
  { id: 11, name: 'Espejo Decorativo', category: 'hogar', price: 48000, image: 'https://images.unsplash.com/photo-1618220179428-22790b461013?w=400', reserved: false, description: 'Espejo con marco dorado' },
  { id: 12, name: 'Cuadros Abstractos Set x3', category: 'hogar', price: 95000, image: 'https://images.unsplash.com/photo-1513519245088-0e12902e35ca?w=400', reserved: false, description: 'Arte moderno para decorar' },
  
  // Cocina
  { id: 13, name: 'Batería de Cocina', category: 'cocina', price: 110000, image: 'https://images.unsplash.com/photo-1556909172-54557c7e4fb7?w=400', reserved: false, description: 'Set completo de ollas y sartenes' },
  { id: 14, name: 'Vajilla Porcelana 24 Piezas', category: 'cocina', price: 88000, image: 'https://images.unsplash.com/photo-1578916171728-46686eac8d58?w=400', reserved: false, description: 'Vajilla elegante para 6 personas' },
  { id: 15, name: 'Set de Cuchillos Profesional', category: 'cocina', price: 75000, image: 'https://images.unsplash.com/photo-1593618998160-e34014e67546?w=400', reserved: true, description: 'Cuchillos de chef de alta calidad' },
  { id: 16, name: 'Parrilla Eléctrica', category: 'cocina', price: 92000, image: 'https://images.unsplash.com/photo-1607532941433-304659e8198a?w=400', reserved: false, description: 'Para los mejores asados indoor' },
  
  // Tecnología
  { id: 17, name: 'Tablet 10 pulgadas', category: 'tecnologia', price: 135000, image: 'https://images.unsplash.com/photo-1561154464-82e9adf32764?w=400', reserved: false, description: 'Tablet para trabajo y entretenimiento' },
  { id: 18, name: 'Auriculares Bluetooth', category: 'tecnologia', price: 58000, image: 'https://images.unsplash.com/photo-1505740420928-5e560c06d30e?w=400', reserved: false, description: 'Sonido premium con cancelación de ruido' },
  { id: 19, name: 'Smart TV 43"', category: 'tecnologia', price: 320000, image: 'https://images.unsplash.com/photo-1593359677879-a4bb92f829d1?w=400', reserved: false, description: 'Televisor 4K Smart' },
  { id: 20, name: 'Parlante Portátil', category: 'tecnologia', price: 42000, image: 'https://images.unsplash.com/photo-1608043152269-423dbba4e7e1?w=400', reserved: false, description: 'Bluetooth con gran autonomía' },
  
  // Luna de Miel
  { id: 21, name: 'Hotel 5 Estrellas - 1 Noche', category: 'luna-de-miel', price: 180000, image: 'https://images.unsplash.com/photo-1566073771259-6a8506099945?w=400', reserved: false, description: 'Noche de lujo con desayuno incluido' },
  { id: 22, name: 'Spa Day para Dos', category: 'luna-de-miel', price: 95000, image: 'https://images.unsplash.com/photo-1544161515-4ab6ce6db874?w=400', reserved: false, description: 'Día completo de relax y masajes' },
  { id: 23, name: 'Excursión Cataratas', category: 'luna-de-miel', price: 250000, image: 'https://images.unsplash.com/photo-1621277224630-81d9af65e40e?w=400', reserved: false, description: 'Viaje a las Cataratas del Iguazú' },
  { id: 24, name: 'Cena Romántica con Vino', category: 'luna-de-miel', price: 65000, image: 'https://images.unsplash.com/photo-1414235077428-338989a2e8c0?w=400', reserved: false, description: 'Cena especial en restaurante exclusivo' },
];

// Mock couple data
export const mockCouple = {
  id: 'maria-y-juan',
  bride: 'María González',
  groom: 'Juan Pérez',
  weddingDate: '2026-03-15',
  eventDetails: {
    ceremony: {
      name: 'Ceremonia Religiosa',
      location: 'Iglesia Nuestra Señora del Carmen',
      address: 'Av. Córdoba 1250, CABA',
      time: '18:00 hs',
      details: 'Por favor llegar 15 minutos antes'
    },
    party: {
      name: 'Fiesta',
      location: 'Salón Las Magnolias',
      address: 'Camino del Buen Ayre km 5.5, Vicente López',
      time: '21:00 hs',
      details: 'Dress code: Formal. Estacionamiento disponible.'
    }
  },
  accountInfo: {
    alias: 'maria.juan.boda',
    cbu: '0000003100010000000000',
    accountHolder: 'María González / Juan Pérez'
  },
  preferences: {
    currency: 'ARS' // or 'USD'
  }
};

// Mock received gifts for admin/couple dashboard
export const mockReceivedGifts = [
  {
    id: 1,
    giftId: 2,
    giftName: 'Licuadora Premium',
    amount: 65000,
    guestName: 'Carla Rodríguez',
    guestEmail: 'carla@email.com',
    guestPhone: '+54 9 11 1234-5678',
    message: '¡Felicidades! Que sean muy felices juntos 💕',
    date: '2026-01-02T14:30:00',
    paymentMethod: 'mercadopago',
    status: 'completed'
  },
  {
    id: 2,
    giftId: 8,
    giftName: 'Pasaje a Brasil',
    amount: 180000,
    guestName: 'Familia Martínez',
    guestEmail: 'flia.martinez@email.com',
    guestPhone: '+54 9 11 9876-5432',
    message: 'Para que disfruten su luna de miel. Los queremos mucho!',
    date: '2026-01-03T10:15:00',
    paymentMethod: 'transferencia',
    status: 'completed'
  },
  {
    id: 3,
    giftId: 15,
    giftName: 'Set de Cuchillos Profesional',
    amount: 75000,
    guestName: 'Pedro Gómez',
    guestEmail: 'pedro.g@email.com',
    guestPhone: '+54 9 11 5555-4444',
    message: 'Que cocinen rico juntos siempre!',
    date: '2026-01-04T09:00:00',
    paymentMethod: 'mercadopago',
    status: 'completed'
  }
];

export default {
  giftCategories,
  mockGifts,
  mockCouple,
  mockReceivedGifts
};
